import { createStore } from '@stencil/store';
import { VoiceState } from 'types';
import { changeOverflowBody } from 'utils/ui';
import initParams from 'store/initParams';

const { state, onChange } = createStore<VoiceState>({
  wsClient: undefined,
  wavRecorder: undefined,
  wavStreamPlayer: undefined,
  isOpen: false,
});

onChange('isOpen', async newValue => {
  changeOverflowBody(newValue, initParams.isApp);
  if (!newValue) {
    state.isOpen = false;
    state.wsClient?.disconnect();
    await state.wavRecorder?.end();
    await state.wavStreamPlayer?.interrupt();
  }
});

export default state;
